import WebApp from '@twa-dev/sdk';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import ru from './locales/ru.json';
import ua from './locales/ua.json';

export type AppLanguage = 'en' | 'ru' | 'ua';

export const SUPPORTED_LANGUAGES: AppLanguage[] = ['en', 'ru', 'ua'];

export const LANGUAGE_LABELS: Record<AppLanguage, string> = {
  en: 'English',
  ru: 'Русский',
  ua: 'Українська',
};

export function normalizeLanguage(raw: string): AppLanguage {
  const base = raw.split('-')[0];
  if (base === 'uk') return 'ua';
  return SUPPORTED_LANGUAGES.includes(base as AppLanguage) ? (base as AppLanguage) : 'en';
}

function resolveInitialLanguage(): AppLanguage {
  const stored = localStorage.getItem('language') as AppLanguage | null;
  if (stored && SUPPORTED_LANGUAGES.includes(stored)) return stored;

  const tgLang = WebApp.initDataUnsafe?.user?.language_code ?? '';
  return normalizeLanguage(tgLang);
}

i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, ru: { translation: ru }, ua: { translation: ua } },
  lng: resolveInitialLanguage(),
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export { i18n };
